package com.arena_web.data.api

import com.arena_web.data.dto.CreateUserStoryRequest
import com.arena_web.data.dto.FeedStoryAuthorGroupPageDto
import com.arena_web.data.dto.ImageUploadResponse
import com.arena_web.data.dto.StoryViewerDto
import com.arena_web.data.dto.UserStoryDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiDelete
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import com.arena_web.data.http.apiPostMultipart
import io.ktor.client.HttpClient

class UserStoryApi(private val client: HttpClient) {

    suspend fun getMyStories(): ApiResponse<List<UserStoryDto>> {
        return client.apiGet("v1/users/me/stories")
    }

    suspend fun getStoriesByUser(userId: String): ApiResponse<List<UserStoryDto>> {
        return client.apiGet("v1/users/$userId/stories")
    }

    suspend fun getActiveFeedStories(): ApiResponse<List<UserStoryDto>> {
        return client.apiGet("v1/feed/stories")
    }

    /** Enriched per-author grouping used by the Feed screen — each group carries
     *  the author's player-card snapshot plus a per-story isSeen flag. */
    suspend fun getFeedStoryAuthors(
        params: Map<String, String> = emptyMap(),
    ): ApiResponse<FeedStoryAuthorGroupPageDto> {
        return client.apiGet("v1/feed/story-authors", params)
    }

    suspend fun markStorySeen(storyId: String): ApiResponse<String> {
        return client.apiPost("v1/feed/stories/$storyId/seen")
    }

    /** Toggle a like on a story. Server returns `{ liked: Boolean }`. */
    suspend fun likeStory(storyId: String): ApiResponse<Map<String, Boolean>> {
        return client.apiPost("v1/feed/stories/$storyId/like")
    }

    /** "Who saw this story?" — everyone who viewed it, most-recent first,
     *  each row flagged `likedByThem`. Public to any authenticated user. */
    suspend fun getStoryViewers(storyId: String): ApiResponse<List<StoryViewerDto>> {
        return client.apiGet("v1/feed/stories/$storyId/viewers")
    }

    suspend fun createStory(request: CreateUserStoryRequest): ApiResponse<UserStoryDto> {
        return client.apiPost("v1/users/me/stories", request)
    }

    suspend fun deleteStory(storyId: String): ApiResponse<Unit> {
        return client.apiDelete("v1/users/me/stories/$storyId")
    }

    suspend fun uploadImage(
        fileBytes: ByteArray,
        fileName: String,
        contentType: String
    ): ApiResponse<ImageUploadResponse> {
        return client.apiPostMultipart(
            "v1/users/me/stories/upload-image",
            fileBytes,
            fileName,
            contentType
        )
    }
}
